import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './translations/en.json';
import sw from './translations/sw.json';
import am from './translations/am.json';
import so from './translations/so.json';
import fr from './translations/fr.json';
import hi from './translations/hi.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      sw: { translation: sw },
      am: { translation: am },
      so: { translation: so },
      fr: { translation: fr },
      hi: { translation: hi }
    },
    fallbackLng: 'en',
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });
export default i18n;